// src/config/institutions.ts
export interface SubInstitution {
  id: string;
  name: string;
  code: string;
  logo?: string; // Alt kuruma özel logo (opsiyonel)
}

export interface Institution {
  id: string;
  name: string;
  code: string;
  domain: string;
  logo: string;
  primaryColor: string;
  secondaryColor?: string;
  subInstitutions?: SubInstitution[]; // Alt kurumlar
}

export const institutions: Record<string, Institution> = {
  default: {
    id: "default",
    name: "TeknoKarne",
    code: "HAL1555",
    domain: "teknokarne.net",
    logo: "/renkli_logo.png",
    primaryColor: "#fb8706",
    secondaryColor: "#6e6e6e",
  },
  ibrahimari: {
    id: "ibrahimari",
    name: "İbrahim Arı Eğitim Kurumları",
    code: "AR51451", // Ana kurum kodu
    domain: "ibrahimari.teknokarne.net",
    logo: "/ibrahimari.png",
    primaryColor: "#2E7D32",
    secondaryColor: "#4CAF50",
    subInstitutions: [
      {
        id: "ibrahimari-kurs",
        name: "İBRAHİM ARI KURS MERKEZİ",
        code: "G027245",
      },
      {
        id: "ibrahimari-ortaokul",
        name: "İBRAHİM ARI ORTAOKUL",
        code: "AR27927",
      },
      {
        id: "ibrahimari-akkent-ortaokul",
        name: "İBRAHİM ARI AKKENT ORTAOKUL",
        code: "AR991251",
      },
      {
        id: "ibrahimari-akkent-ozel",
        name: "AKKENT İBRAHİM ARI ÖZEL ÖĞRETİM",
        code: "LOGO1425",
      },
      {
        id: "ibrahimari-lise",
        name: "İBRAHİM ARI ANADOLU LİSE",
        code: "AR51451",
      },
    ],
  },
  // Diğer kurumları buraya ekleyebilirsiniz
};

export const getInstitutionByDomain = (hostname: string): Institution => {
  // Subdomain'i al
  const parts = hostname.split(".");
  const isSubdomain = parts.length > 2;
  const subdomain = isSubdomain ? parts[0] : "";

  // Subdomain'e göre kurumu bul
  for (const key in institutions) {
    const institution = institutions[key];
    // Burada subdomain'i kurum kodu ile değil, kurum ID'si ile karşılaştırmalıyız
    if (subdomain === key || subdomain === institution.id) {
      return institution;
    }
  }

  // Eğer subdomain bulunamazsa, varsayılan kurumu döndür
  return institutions.default;
};

export const getCurrentInstitution = (): Institution => {
  return getInstitutionByDomain(window.location.hostname);
};
